import { defineMessages } from "react-intl"

export default defineMessages({
  dlcTypes: {
    id: "app.components.DlcContents.dlcTypes",
  },
  "dlcTypes.Characters": {
    id: "app.components.DlcContents.dlcTypes.Characters",
  },
  "dlcTypes.Cosmetics": {
    id: "app.components.DlcContents.dlcTypes.Cosmetics",
  },
  "dlcTypes.Item": {
    id: "app.components.DlcContents.dlcTypes.Item",
  },
  "dlcTypes.AdditionalGameContent": {
    id: "app.components.DlcContents.dlcTypes.AdditionalGameContent",
  },
  "dlcTypes.SeasonsPass": {
    id: "app.components.DlcContents.dlcTypes.SeasonsPass",
  },
  "dlcTypes.Lootboxes": {
    id: "app.components.DlcContents.dlcTypes.Lootboxes",
  },
  "dlcTypes.BoosterPacks": {
    id: "app.components.DlcContents.dlcTypes.BoosterPacks",
  },
  "dlcTypes.BattlePass": {
    id: "app.components.DlcContents.dlcTypes.BattlePass",
  },
  "dlcTypes.MoneyPacks": {
    id: "app.components.DlcContents.dlcTypes.MoneyPacks",
  },
})
